(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/assets/javascripts/views/play-package-page.js') >= 0) return;  svs.modules.push('/modules/lotto/assets/javascripts/views/play-package-page.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  draws: {
    drawsUtils
  },
  productMapping,
  rules
} = svs.numbergames;
const getRules = days => {
  var _days;
  if (!((_days = days) !== null && _days !== void 0 && _days.length)) {
    days = 'lotto';
  }
  const [draw] = drawsUtils.sortProductsByDrawTime(days);
  const PACKAGES = rules.getRules('lotto', {
    product: draw === null || draw === void 0 ? void 0 : draw.productItsId,
    drawNumber: draw === null || draw === void 0 ? void 0 : draw.drawNumber
  }).PACKAGES;
  const lottoRules = rules.getRules('lotto');
  return _objectSpread(_objectSpread({}, lottoRules), {}, {
    PACKAGES
  });
};
svs.lotto.views.PlayPackagePage = Marionette.View.extend({
  viewOptions: ['size', 'showDrawCount', 'showPlayTogether'],
  showDrawCount: true,
  showPlayTogether: true,
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'lotto',
    component: 'play'
  }],
  regions: {
    rowsContainerRegion: '#ngRowsContainerRegion',
    betslipRegion: '#ngBetslipRegion',
    payfooterRegion: '#ngPayfooterRegion'
  },
  modelEvents: {
    'change:selectedDays': 'updateRules'
  },
  template(data) {
    return svs.lotto.templates.play_page(data);
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    if (svs.lotto.components.play) {
      var _this$model;
      (_this$model = this.model) !== null && _this$model !== void 0 ? _this$model : this.model = new svs.numbergames.game_model.models.Wager({
        productId: productMapping.CONSTANTS.LOTTO,
        jokerPrice: 10,
        jokerRow: svs.numbergames.rules.joker.getHuxfluxedRow(),
        rowPriceMulti: 2,
        selectedDays: [svs.numbergames.game.draw.upcomingDrawProduct],
        isPackage: true
      }, {
        storageKey: 'package',
        parse: true,
        hasTickets: svs.lotto.data.hasTickets,
        rules: getRules()
      });
      this.unbindEvents(this.model, this.modelEvents);
      this.bindEvents(this.model, this.modelEvents);
      this.model.setPackage(this.size);
      this.showChildView('rowsContainerRegion', new svs.lotto.components.play.views.PackageRowsContainer({
        model: this.model
      }));
      this.showChildView('betslipRegion', new svs.lotto.components.play.views.Betslip({
        model: this.model,
        showJoker: false,
        showParticipation: false,
        showDrawCount: this.showDrawCount,
        showPlayTogether: this.showPlayTogether
      }));
      this.showChildView('payfooterRegion', new svs.lotto.components.play.views.Payfooter({
        model: this.model
      }));
      this.updateRules();
    }
  },
  updateRules() {
    svs.numbergames.game_model.rulesRadio.trigger('setRules', getRules(this.model.get('selectedDays')));
    this.model.updatePackages();
  }
});

 })(window);